<template>
  <div class="app-wrapper">
    <el-container>
      <el-aside width="162px">
        <index-user-info :user-info="userInfo"></index-user-info>
        <site-menu :user-info="userInfo"></site-menu>
      </el-aside>
      <el-container>
        <el-header style="height: 97px">
          <index-header></index-header>
          <!-- 面包屑 -->
          <breadcrumb />
        </el-header>
        <el-main class="app-main">
          <transition name="fade">
          <router-view
            :org-id="userInfo.origanization"
            :user-info="userInfo"
           />
          </transition>
        </el-main>
        <el-footer class="footer" style="height: 32px;">
          <span>2020©版权所有&nbsp;&nbsp;深圳市海云天科技股份有限公司&nbsp;&nbsp;
            <a style="color: #685f26; text-decoration: unset;" href="http://beian.miit.gov.cn" target="_blank" class="footer-word">粤ICP备13057678号</a>
            <!-- 粤ICP备13057678号-4 -->
          </span>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import common from '@/util/common'
import IndexHeader from './IndexHeader'
import IndexUserInfo from './IndexUserInfo'
import SiteMenu from './SiteMenu'
import Breadcrumb from './Breadcrumb'
import { getUserInfo } from '@/model/user-model'
import { IndexRedirect } from '@/components/mixins/InfoSource'

export default {
  name: 'Index',
  data () {
    return {

    }
  },
  mixins: [IndexRedirect],
  computed: {
    userInfo () {
      return common.getUserInfo()
    }
  },
  components: {
    IndexHeader,
    IndexUserInfo,
    SiteMenu,
    Breadcrumb
  },
  methods: {
    menuRouterTo (url) {
      this.$router.push(url)
    }
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    console.log('beforeRouteEnter')
    if (to.query.userId) {
      getUserInfo({userId: to.query.userId}).then((userData) => {
        if (!userData.result) {
          sessionStorage.setItem('user_info', JSON.stringify(userData))
        }
        if (to.query.defaultKey) {
          sessionStorage.setItem('default_key', to.query.defaultKey)
        }
        next()
      })
    } else {
      next()
    }
  },
  created () {
    console.log('indexCreated')
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.app-wrapper {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  .el-header{
    padding: 0;
  }
  .app-main{
    overflow: hidden;
    background: white;
    padding: 30px 30px 30px 30px;
    height: calc(100vh - 32px - 97px);;
  }
  .footer {
    margin: 0 auto;
    color: #685f26;
    font-size: 12px;
    line-height: 32px;
    background: white;
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home-work/Index.vue